import { useQuery } from "@tanstack/react-query";
import { getCustomers } from "../api/customers";
import { QueryResponse } from "../utils/data-types";

// state manager custom hook to check logged in users permissions
export function useCheckPermissions(): QueryResponse {
    return useQuery({ queryKey: ["customers-permissions"], queryFn: () => getCustomers(), staleTime: 60 * 1000 * 60 }) // one hour stale time

}